import { useMemo } from 'react';

import { BookingSlot } from '../../api/search';
import { groupSlots, prepareWeekEntries, WeekEntry } from '../../utils/weekly';

export const useSlotsPerWeek = (slots: BookingSlot[]) => {
  const slotsGrouped = useMemo(() => groupSlots(slots), [slots]);

  const weekEntries = useMemo(
    () => prepareWeekEntries(slotsGrouped),
    [slotsGrouped]
  );

  const weekEntriesById = useMemo(
    () =>
      weekEntries.reduce(
        (acc, entry) => ({
          ...acc,
          [entry.id]: entry,
        }),
        {} as Record<string, WeekEntry>
      ),
    [weekEntries]
  );

  return {
    slotsPerWeek: slotsGrouped.slotsPerWeek,
    weekEntries,
    weekEntriesById,
  };
};
